// extracted by mini-css-extract-plugin
export var hidden = "socialmedia-module--hidden--3FHlB";
export var mailcrypt = "socialmedia-module--mailcrypt--5U9NL";
export var socialmedia = "socialmedia-module--socialmedia--qkAL6";